/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DisconnectSlackDirectoryConnectionRequestBody,
  DisconnectSlackDirectoryConnectionRequestBody$Outbound,
  DisconnectSlackDirectoryConnectionRequestBody$outboundSchema,
} from "../components/disconnectslackdirectoryconnectionrequestbody.js";

export type DisconnectSlackDirectoryConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DisconnectSlackDirectoryConnectionRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  disconnectSlackDirectoryConnectionRequestBody:
    DisconnectSlackDirectoryConnectionRequestBody;
};

/** @internal */
export type DisconnectSlackDirectoryConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DisconnectSlackDirectoryConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    DisconnectSlackDirectoryConnectionSecurity$Outbound,
    DisconnectSlackDirectoryConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function disconnectSlackDirectoryConnectionSecurityToJSON(
  disconnectSlackDirectoryConnectionSecurity:
    DisconnectSlackDirectoryConnectionSecurity,
): string {
  return JSON.stringify(
    DisconnectSlackDirectoryConnectionSecurity$outboundSchema.parse(
      disconnectSlackDirectoryConnectionSecurity,
    ),
  );
}

/** @internal */
export type DisconnectSlackDirectoryConnectionRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  DisconnectSlackDirectoryConnectionRequestBody:
    DisconnectSlackDirectoryConnectionRequestBody$Outbound;
};

/** @internal */
export const DisconnectSlackDirectoryConnectionRequest$outboundSchema:
  z.ZodMiniType<
    DisconnectSlackDirectoryConnectionRequest$Outbound,
    DisconnectSlackDirectoryConnectionRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      disconnectSlackDirectoryConnectionRequestBody:
        DisconnectSlackDirectoryConnectionRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        disconnectSlackDirectoryConnectionRequestBody:
          "DisconnectSlackDirectoryConnectionRequestBody",
      });
    }),
  );

export function disconnectSlackDirectoryConnectionRequestToJSON(
  disconnectSlackDirectoryConnectionRequest:
    DisconnectSlackDirectoryConnectionRequest,
): string {
  return JSON.stringify(
    DisconnectSlackDirectoryConnectionRequest$outboundSchema.parse(
      disconnectSlackDirectoryConnectionRequest,
    ),
  );
}
